import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import classNames from "classnames";
import { SportCodes } from "@prestosports/prestostats-core/Common";
import BoxScoreTeamSummary from "./BoxScoreTeamSummary";
import scoreBoardStyles from "../styles/ScoreBoard.styles";
import DateFormat from "../../../util/date-format";
import boxScoreStyles from "../styles/BoxScore.styles";

const ScoreBoard = ({
	swapTeams,
	awayTeam,
	awayScore,
	homeTeam,
	homeScore,
	startDateTime,
	venue,
	periodNumber,
	time,
	isFinal,
	sportId
}) => {
	const classes = scoreBoardStyles();
	const boxScoreClasses = boxScoreStyles();

	const sportContent = () => {
		switch (sportId) {
			case SportCodes.Tennis:
			case SportCodes.WomenTennis:
				return `${isFinal ? "FINAL" : " - "}`;
			case SportCodes.FlagFootball:
			case SportCodes.Football:
				return `Q${periodNumber} - ${DateFormat.formatMilliseconds(time, "mm:ss")}`;
			default:
				return " - ";
		}
	};

	return (
		<>
			<Grid
				container
				justifyContent="space-between"
				alignItems="center"
				direction={swapTeams ? "row-reverse" : "row"}
			>
				<Grid item className={classes.teamSummary}>
					<BoxScoreTeamSummary
						team={awayTeam}
						reversed={!swapTeams}
						score={awayScore}
					/>
				</Grid>
				<Grid item>
					<Typography
						variant="inherit"
						className={classNames(classes.overall, classes.eventText, {
							[boxScoreClasses.inProgress]: !isFinal,
							[boxScoreClasses.final]: isFinal
						})}
					>
						{sportContent()}
					</Typography>
				</Grid>
				<Grid item className={classes.teamSummary}>
					<BoxScoreTeamSummary
						team={homeTeam}
						reversed={swapTeams}
						score={homeScore}
					/>
				</Grid>
			</Grid>
			<Grid container justifyContent="center">
				<Grid item>
					<Typography
						variant="inherit"
						className={classNames(classes.eventText, classes.eventSummary)}
					>
						{DateFormat.format(startDateTime, "ddd, MMM DD, yyyy")}
						{venue && ` - ${venue}`}
					</Typography>
				</Grid>
			</Grid>
		</>
	);
};

export default ScoreBoard;
